module.exports = __webpack_public_path__ + "static/concours-4acf6f6f6fb437e797caef292804398e.png";